// Package Imports
import { useState } from 'react';
import { Button, Col, Form, Row } from 'antd';
import { useNavigation, useTranslate } from '@refinedev/core';
import { SaveButton } from '@refinedev/antd';

// Project Imports
import TextInput from 'components/text/textInput';
import TextAreaInput from 'components/textarea/textAreaInput';
import constants from 'core/constants/Constants';
import RangeInput from 'components/date/rangeInput';
import SegmentInput from 'components/segment/SegmentInput';
import DropdownInput from 'components/dropdown/dropDownInput';

import CustomModal from 'components/modal/modal';
import regex from 'core/constants/Regex';
import resourceName from 'core/common/resourceName';
import getFooterButton from 'core/utils/getFooterButton';
import { useTokenContext } from 'contexts/resource/ResourceContext';

const RulePlansForm = ({
  configData,
  formData,
  eventHandler,
  stateFunctionHandler,
  stateData,
  staticData,
}: any) => {
  const t = useTranslate();
  const { form, formProps, saveButtonProps } = formData;
  const { onFinishHandler } = eventHandler;
  const { setIsUnifiedChange, setIsUnifiedDeleted, setStatusModal } =
    stateFunctionHandler;
  const { unifiedList, rulesData, isUnifiedDeleted, statusModal, saveLoading } =
    stateData;
  const { type } = staticData;
  const { disabled } = configData;
  const { list } = useNavigation();
  const { compensationType } = useTokenContext();

  const activeStatus = [
    { label: t('rulePlans.rulePlanActive'), value: true },
    { label: t('rulePlans.rulePlanInactive'), value: false },
  ];
  const initialValues = {
    rule_plan_is_active: true,
  };
  const isValuesPresent = formProps?.initialValues?.results || initialValues;

  const [open, setOpen] = useState(false);
  const showModal = () => {
    setOpen(true);
  };

  const hideModal = (val) => {
    const value = form.getFieldValue('unified_source_master_id');
    const previousValue = rulesData?.unified_source_master_id;
    if (val === 'Ok') {
      form.setFieldsValue({
        unified_source_master_id: value,
      });
      setIsUnifiedChange(true);
    } else {
      form.setFieldsValue({
        unified_source_master_id: previousValue,
      });
      setIsUnifiedChange(false);
    }
    setOpen(false);
  };

  const handleUnifiedChange = () => {
    if (!isUnifiedDeleted) {
      if (rulesData) {
        showModal();
      }
    }
    setIsUnifiedDeleted(false);
  };
  const hideRulePlanModal = () => {
    setStatusModal(false);
  };

  return (
    <>
      <Form
        {...formProps}
        form={form}
        onFinish={onFinishHandler}
        disabled={type === 'Show' || disabled}
        initialValues={isValuesPresent}
        size="large"
        layout="vertical"
      >
        {/* New code start */}
        {/* <div className="grid grid-cols-12 gap-4"> */}
        <Row className="">
          <Col lg={24}>
            <Row gutter={16} className="">
              <Col xs={24} md={12} lg={6}>
                <TextInput
                  label={t('rulePlans.rulePlansName')}
                  name="rule_plan_name"
                  required={true}
                  message={t('rulePlans.messages.rulePlansName')}
                  placeholder={t('rulePlans.messages.rulePlansName')}
                  disabled={type === 'Show'}
                  rules={{
                    pattern: regex.nameCheck,
                    message: t('errorMessages.rulenameValidMsg'),
                  }}
                />
              </Col>
              <Col xs={24} md={12} lg={6}>
                <RangeInput
                  label={t('rulePlans.rulePlanDate')}
                  name="rule_plans_date"
                  required={true}
                  message={t('rulePlans.messages.rulePlanDate')}
                  format={constants.dateFormat}
                  disabled={type === 'Show'}
                />
              </Col>
              <Col xs={24} md={8} lg={6}>
                <DropdownInput
                  label={t('rulePlans.unifiedFile')}
                  name="unified_source_master_id"
                  required={true}
                  optionList={unifiedList}
                  message={t('rulePlans.selectUnifiedFile')}
                  placeholder={t('rulePlans.selectUnifiedFile')}
                  disabled={type === 'Show' || rulesData?.is_unification_done}
                  onChange={() => handleUnifiedChange()}
                  showSearch={true}
                  optionFilterProp="label"
                  filterOption={(input, option) =>
                    option?.label.toLowerCase().includes(input.toLowerCase())
                  }
                />
              </Col>
              {compensationType === 'cash_points' ? (
                <Col xs={24} md={8} lg={6}>
                  <DropdownInput
                    label={t('rulePlans.type')}
                    name="rule_plan_compensation_type"
                    required={true}
                    optionList={[
                      { label: t('compensationType.points'), value: 'points' },
                      { label: t('compensationType.cash'), value: 'cash' },
                    ]}
                    message={t('rulePlans.selectRulePlanType')}
                    placeholder={t('rulePlans.selectRulePlanType')}
                    showSearch={true}
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option?.label.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </Col>
              ) : null}
            </Row>

            <Row gutter={16}>
              <Col xs={24} sm={24} lg={16} className="">
                <TextAreaInput
                  label={t('rulePlans.rulePlanDescription')}
                  name="rule_description"
                  message={t('rulePlans.messages.rulePlanDescription')}
                  placeholder={t('rulePlans.messages.rulePlanDescription')}
                  rows={4}
                  required={false}
                  disabled={type === 'Show'}
                />
              </Col>
              <Col xs={24} md={12} lg={8} className="">
                <label className="floating-label">{t('common.status')}</label>
                <SegmentInput
                  name="rule_plan_is_active"
                  optionList={activeStatus}
                  disabled={
                    type === 'Show' ||
                    rulesData?.mapped_in_program_config === true
                  }
                />
              </Col>
            </Row>
          </Col>
        </Row>
        {/* </div> */}
        {type !== 'Show' ? (
          <div className="flex justify-end gap-x-sm">
            {type === 'Create' ? (
              <Button
                className="cancel-button w-[80px]"
                onClick={() => list(resourceName?.rulePlans)}
              >
                {t('buttons.cancel')}
              </Button>
            ) : null}
            <SaveButton
              icon={false}
              className="mb-md min-w-[80px]"
              {...saveButtonProps}
              loading={saveLoading}
            >
              {t('buttons.save')}
            </SaveButton>
          </div>
        ) : null}
      </Form>
      <CustomModal
        openModal={open}
        hideModal={hideModal}
        title={t('common.note')}
        okText="Ok"
        cancelText="Cancel"
        message={t('rulePlans.unifiedFileOnchangeAlert')}
      />
      <CustomModal
        openModal={statusModal}
        hideModal={hideRulePlanModal}
        title={t('common.note')}
        message={
          rulesData?.rule_plan_is_active
            ? t('rulePlans.messages.rulePlanInactiveAlert')
            : t('rulePlans.messages.rulePlanActiveAlert')
        }
        footer={getFooterButton(
          rulesData?.rule_plan_is_active, // true means old state is active and new state is  inactive
          saveButtonProps,
          form,
          onFinishHandler,
          t
        )}
      />
    </>
  );
};

export default RulePlansForm;
